export default {
  classifierAccessList: state => {
    let list = []
    state.dbAccessList.map(item => {
      list.push({
        id: item.id,
        access: item.access
      })
    })
    list.splice(0, 1)
    return list
  }
}



// WEBPACK FOOTER //
// ./src/store/employee/getters.js